(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      /* Host = <sticky-header class="header-wrapper ..."> */
      this.sectionHeader = document.querySelector('.section-header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollThreshold = 50;
      this.reduceLogo = (this.getAttribute('data-sticky-type') || '') === 'reduce-logo-size';
      this._wasScrolled = null;

      this._boundSetHeight = this.setHeaderHeight.bind(this);
      this._boundOnScroll = this.onScroll.bind(this);

      this.classList.remove('scrolled');
      this._mq = window.matchMedia('(max-width: 990px)');
      this._mq.addEventListener('change', this._boundSetHeight);
      window.addEventListener('scroll', this._boundOnScroll, { passive: true });
      window.addEventListener('resize', this._boundSetHeight);

      if (this.sectionHeader) {
        this.sectionHeader.classList.remove(
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'header-layer--top',
          'header-layer--scrolled',
          'animate',
          'scrolled-past-header'
        );
      }

      requestAnimationFrame(() => {
        this.onScroll();
        this.setHeaderHeight();
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${Math.round(this.offsetHeight)}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._boundOnScroll);
      window.removeEventListener('resize', this._boundSetHeight);
      if (this._mq) this._mq.removeEventListener('change', this._boundSetHeight);
    }

    onScroll() {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrolled = scrollTop > this.scrollThreshold;

      if (this._wasScrolled === scrolled) return;
      this._wasScrolled = scrolled;

      this.classList.toggle('scrolled', scrolled);

      if (this.sectionHeader && this.reduceLogo) {
        this.sectionHeader.classList.toggle('scrolled-past-header', scrolled);
      }

      this.setHeaderHeight();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
